import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Root of all mutations. */
export type MutationRoot = {
  __typename?: 'MutationRoot';
  activate_device: User_Device_Either;
  ad_completed: Event_Mutation_Response;
  ad_error: Event_Mutation_Response;
  ad_skipped: Event_Mutation_Response;
  ad_started: Event_Mutation_Response;
  app_comments_create: App_Comment_Create_Response;
  app_comments_delete: App_Comment_Delete_Response;
  button_clicked: Event_Mutation_Response;
  campaign_register: Scalars['String']['output'];
  cancel_subscription: Payment_Operation_Response;
  change_payment_settings: Payment_Operation_Response;
  change_product: Payment_Operation_Response;
  check_reset_token: Check_Reset_Token_Response;
  content_review_update_media: Content_Review_Update_Media_Response;
  content_review_update_title: Content_Review_Update_Title_Response;
  create_comment: Create_Comment_Either;
  create_free_member: Create_Free_Member_Response;
  delete_comment: Scalars['String']['output'];
  edit_comment: Edit_Comment_Either;
  forgot_password: Scalars['String']['output'];
  inactivate_device: User_Device_Either;
  list_item_clicked: Event_Mutation_Response;
  logged_reset_password: Scalars['String']['output'];
  login: Login;
  migrate_token: Login;
  my_bp_update_media: My_Bp_Update_Media_Response;
  my_bp_update_title: My_Bp_Update_Title_Response;
  oauth_authorization: Authorization_Response;
  product_change_info: Product_Change_Info;
  purgatorium_init_session: Purgatorium_Session;
  purgatorium_maybe_transfer_token: Scalars['Boolean']['output'];
  purgatorium_transfer_token: Scalars['String']['output'];
  reactivate_subscription: Payment_Operation_Response;
  refresh_token: Login;
  remove_current_download: Remove_Current_Download;
  reset_password: Scalars['String']['output'];
  revert_change_product: Payment_Operation_Response;
  screen_requested: Event_Mutation_Response;
  send_privacy_form: Scalars['String']['output'];
  shadow_comment: Create_Comment_Either;
  show_user_comments_disclaimer: User_Comments_Disclaimer_Either;
  sync_payment_settings: Sync_Payment_Settings_Response;
  sync_with_client: Sync_With_Client_Status;
  update_avatar: Scalars['String']['output'];
  update_checkpoint: Scalars['String']['output'];
  update_cookies: Cookies;
  update_ended: Scalars['String']['output'];
  update_media_completed: Scalars['String']['output'];
  update_profile: User_Profile_Either;
  update_user_settings: User_Settings_Either;
};


/** Root of all mutations. */
export type MutationRootActivate_DeviceArgs = {
  input: Device_Handling_Input;
};


/** Root of all mutations. */
export type MutationRootAd_CompletedArgs = {
  input: Ad_Event_Input;
};


/** Root of all mutations. */
export type MutationRootAd_ErrorArgs = {
  input: Ad_Event_Input;
};


/** Root of all mutations. */
export type MutationRootAd_SkippedArgs = {
  input: Ad_Event_Input;
};


/** Root of all mutations. */
export type MutationRootAd_StartedArgs = {
  input: Ad_Event_Input;
};


/** Root of all mutations. */
export type MutationRootApp_Comments_CreateArgs = {
  input: App_Comment_Create_Input;
};


/** Root of all mutations. */
export type MutationRootApp_Comments_DeleteArgs = {
  input: App_Comment_Delete_Input;
};


/** Root of all mutations. */
export type MutationRootButton_ClickedArgs = {
  input: Button_Clicked_Input;
};


/** Root of all mutations. */
export type MutationRootCampaign_RegisterArgs = {
  input: Campaign_Register_Input;
};


/** Root of all mutations. */
export type MutationRootCancel_SubscriptionArgs = {
  input: Cancel_Subscription_Input;
};


/** Root of all mutations. */
export type MutationRootChange_Payment_SettingsArgs = {
  input: Change_Payment_Settings_Input;
};


/** Root of all mutations. */
export type MutationRootChange_ProductArgs = {
  input: Change_Product_Input;
};


/** Root of all mutations. */
export type MutationRootCheck_Reset_TokenArgs = {
  input: Check_Reset_Token_Input;
};


/** Root of all mutations. */
export type MutationRootContent_Review_Update_MediaArgs = {
  input: Content_Review_Update_Media_Input;
};


/** Root of all mutations. */
export type MutationRootContent_Review_Update_TitleArgs = {
  input: Content_Review_Update_Title_Input;
};


/** Root of all mutations. */
export type MutationRootCreate_CommentArgs = {
  input: Comment_Input;
};


/** Root of all mutations. */
export type MutationRootCreate_Free_MemberArgs = {
  input: Free_Member_Input;
};


/** Root of all mutations. */
export type MutationRootDelete_CommentArgs = {
  input: Delete_Comment_Input;
};


/** Root of all mutations. */
export type MutationRootEdit_CommentArgs = {
  input: Edit_Comment_Input;
};


/** Root of all mutations. */
export type MutationRootForgot_PasswordArgs = {
  input: Forgot_Password_Input;
};


/** Root of all mutations. */
export type MutationRootInactivate_DeviceArgs = {
  input: Device_Handling_Input;
};


/** Root of all mutations. */
export type MutationRootList_Item_ClickedArgs = {
  input: List_Item_Clicked_Input;
};


/** Root of all mutations. */
export type MutationRootLoginArgs = {
  input: Login_Input;
};


/** Root of all mutations. */
export type MutationRootMigrate_TokenArgs = {
  input: Migrate_Token_Input;
};


/** Root of all mutations. */
export type MutationRootMy_Bp_Update_MediaArgs = {
  input: My_Bp_Update_Media_Input;
};


/** Root of all mutations. */
export type MutationRootMy_Bp_Update_TitleArgs = {
  input: My_Bp_Update_Title_Input;
};


/** Root of all mutations. */
export type MutationRootOauth_AuthorizationArgs = {
  input: Authorization_Input;
};


/** Root of all mutations. */
export type MutationRootProduct_Change_InfoArgs = {
  input: Product_Change_Info_Input;
};


/** Root of all mutations. */
export type MutationRootPurgatorium_Maybe_Transfer_TokenArgs = {
  input: Purgatorium_Token_Input;
};


/** Root of all mutations. */
export type MutationRootPurgatorium_Transfer_TokenArgs = {
  input: Purgatorium_Token_Input;
};


/** Root of all mutations. */
export type MutationRootReactivate_SubscriptionArgs = {
  input: Reactivate_Subscription_Input;
};


/** Root of all mutations. */
export type MutationRootRefresh_TokenArgs = {
  input: Refresh_Token_Input;
};


/** Root of all mutations. */
export type MutationRootRemove_Current_DownloadArgs = {
  input: Remove_Current_Download_Input;
};


/** Root of all mutations. */
export type MutationRootReset_PasswordArgs = {
  input: Reset_Password_Input;
};


/** Root of all mutations. */
export type MutationRootRevert_Change_ProductArgs = {
  input: Revert_Change_Product_Input;
};


/** Root of all mutations. */
export type MutationRootScreen_RequestedArgs = {
  input: Screen_Requested_Input;
};


/** Root of all mutations. */
export type MutationRootSend_Privacy_FormArgs = {
  input: Send_Privacy_Form_Input;
};


/** Root of all mutations. */
export type MutationRootShadow_CommentArgs = {
  input: Comment_Shadow_Input;
};


/** Root of all mutations. */
export type MutationRootShow_User_Comments_DisclaimerArgs = {
  input: Comment_Disclaimer_Input;
};


/** Root of all mutations. */
export type MutationRootSync_Payment_SettingsArgs = {
  input: Sync_Payment_Settings_Input;
};


/** Root of all mutations. */
export type MutationRootSync_With_ClientArgs = {
  input: Sync_With_Client_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_AvatarArgs = {
  input: Update_Avatar_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_CheckpointArgs = {
  input: Update_Checkpoint_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_CookiesArgs = {
  input: Cookies_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_EndedArgs = {
  input: Update_Ended_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_Media_CompletedArgs = {
  input: Update_Media_Completed_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_ProfileArgs = {
  input: Update_Profile_Input;
};


/** Root of all mutations. */
export type MutationRootUpdate_User_SettingsArgs = {
  input: User_Settings_Input;
};

/** Root of all queries. */
export type QueryRoot = {
  __typename?: 'QueryRoot';
  active_subscription: Active_Subscription;
  app_bff_keep_watching: App_Category_Bff;
  app_comments_get: App_Comment_Get_Response;
  app_home: App_Home;
  app_page_banner_bff: App_Content_Bff;
  app_page_bff: App_Page_Bff;
  app_page_bff_home: App_Page_Bff;
  app_share_campaign: Share_Campaign_Either;
  auditorium: Castle;
  auditorium_bff: Auditorium_Bff;
  auditorium_catalog: Array<Playlist>;
  available_payment_methods: Payment_Methods_Either;
  available_product_changes: Available_Product_Changes_Either;
  castle: Castle;
  castle_keep_watching: Array<Playlist>;
  castle_playlist: Array<Playlist>;
  comments: Comments;
  config: Config;
  cookies: Cookies;
  download_drm_license: Drm_License;
  download_license_permission: Download_License_Permission;
  drm_license: Drm_License;
  drm_license_by_key: Drm_License;
  drm_license_v_2: Drm_License;
  dynamic_category: Category;
  feature_flag: Feature_Flag;
  freemium_offer: Freemium_Offer;
  general_info: General_Info;
  home: Array<Category>;
  home_web: Castle;
  keep_watching: Array<Playlist>;
  last_transaction_info: Transaction;
  last_transactions: Array<Last_Transaction>;
  latest: Latest;
  list_user_downloads: Downloads_List;
  live: Live;
  lives: Array<Live>;
  main_banner: Banner;
  media: Media;
  media_live: Media;
  member_status: Scalars['String']['output'];
  member_upgrade_simulation: Product_Change_Info;
  mobile_app_can_download: Mobile_App_Can_Download;
  mobile_app_cast_standby_page: Mobile_App_Cast_Standby_Page_Response;
  mobile_app_download_limit: Mobile_App_Download_Limit;
  mobile_app_list_page: Mobile_App_List_Page;
  mobile_app_live_details_page: Mobile_App_Live_Details_Page_Response;
  mobile_app_my_bp_medias_page: Mobile_App_My_Bp_Medias_Page_Response;
  mobile_app_my_bp_page: Mobile_App_My_Bp_Page_Response;
  mobile_app_my_bp_titles_page: Mobile_App_My_Bp_Titles_Page_Response;
  mobile_app_title_details_page: Mobile_App_Title_Details_Page_Response;
  mobile_app_trending_page: Mobile_App_Trending_Page;
  my_bp: My_Bp;
  oauth_clients: Oauth_Client_Response;
  page: Page;
  player_language_options: Player_Language_Settings;
  playlist: Playlist;
  product_page: Product_Page;
  products_page: Products_Page;
  products_subscriptions: Array<Product_Subscriptions>;
  purchases: Purchases;
  purgatorium_maybe_token: Purgatorium_Maybe_Token;
  purgatorium_token?: Maybe<Scalars['String']['output']>;
  ribbon_mobile: Ribbon;
  ribbon_princess: Ribbon;
  royal_comments: Array<Comment>;
  schedule: Array<Schedule>;
  screen_sessions: Screen_Sessions;
  search: Search_Result;
  share_campaign: Share_Campaign_Either;
  tv_app_keep_watching: Tv_App_Keep_Watching;
  tv_app_list_page: Tv_App_List_Page;
  tv_app_menu: Tv_App_Menu;
  tv_app_search: Tv_App_Search;
  tv_app_title_detail_page: Tv_App_Title_Detail_Page;
  user: User;
  user_gifts: User_Gifts;
};


/** Root of all queries. */
export type QueryRootApp_Bff_Keep_WatchingArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootApp_Comments_GetArgs = {
  last_post?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  media_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootApp_Page_Banner_BffArgs = {
  page_slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootApp_Page_BffArgs = {
  page_slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootApp_Share_CampaignArgs = {
  playlist_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootAuditorium_BffArgs = {
  scale?: InputMaybe<Scalars['Float']['input']>;
};


/** Root of all queries. */
export type QueryRootAvailable_Payment_MethodsArgs = {
  gateway_code: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootAvailable_Product_ChangesArgs = {
  gateway_code: Scalars['String']['input'];
  operation?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootCastle_Keep_WatchingArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootCastle_PlaylistArgs = {
  search: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootCommentsArgs = {
  media: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


/** Root of all queries. */
export type QueryRootDownload_Drm_LicenseArgs = {
  drm_type: Scalars['String']['input'];
  license_challenge: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootDownload_License_PermissionArgs = {
  media_id: Scalars['String']['input'];
  playlist_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootDrm_LicenseArgs = {
  device_id?: InputMaybe<Scalars['String']['input']>;
  drm_type?: InputMaybe<Scalars['String']['input']>;
  hdcp?: InputMaybe<Scalars['Boolean']['input']>;
  license_challenge: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  persistent?: InputMaybe<Scalars['Boolean']['input']>;
  playlist_id?: InputMaybe<Scalars['String']['input']>;
  session_token: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootDrm_License_By_KeyArgs = {
  drm_type: Scalars['String']['input'];
  license_challenge: Scalars['String']['input'];
  manifest_url: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootDrm_License_V_2Args = {
  drm_type: Scalars['String']['input'];
  license_challenge: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootDynamic_CategoryArgs = {
  category: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootFeature_FlagArgs = {
  name: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootLast_Transaction_InfoArgs = {
  gateway_code: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootList_User_DownloadsArgs = {
  user_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootLiveArgs = {
  id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootMain_BannerArgs = {
  page?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootMediaArgs = {
  media_id: Scalars['String']['input'];
  playlistid?: InputMaybe<Scalars['String']['input']>;
  playlistslug?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootMember_StatusArgs = {
  email: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootMobile_App_Can_DownloadArgs = {
  media_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootMobile_App_List_PageArgs = {
  slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootMobile_App_Live_Details_PageArgs = {
  id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootMobile_App_Title_Details_PageArgs = {
  slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootMy_BpArgs = {
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Root of all queries. */
export type QueryRootOauth_ClientsArgs = {
  client_id: Scalars['String']['input'];
  redirect_uri: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootPageArgs = {
  last_launched?: InputMaybe<Scalars['Boolean']['input']>;
  page_slug: Scalars['String']['input'];
  remove_raw_sources?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root of all queries. */
export type QueryRootPlayer_Language_OptionsArgs = {
  audio_languages: Array<Scalars['String']['input']>;
  media_id: Scalars['String']['input'];
  playlist_id: Scalars['String']['input'];
  shaka_player_version?: InputMaybe<Scalars['String']['input']>;
  subtitles_languages: Array<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootPlaylistArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootProduct_PageArgs = {
  slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootProducts_PageArgs = {
  allowed_only?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root of all queries. */
export type QueryRootPurgatorium_Maybe_TokenArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootPurgatorium_TokenArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootRoyal_CommentsArgs = {
  earlier_than?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  media: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootSearchArgs = {
  search: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootShare_CampaignArgs = {
  playlist_id: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootTv_App_List_PageArgs = {
  slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootTv_App_SearchArgs = {
  search_terms?: InputMaybe<Scalars['String']['input']>;
};


/** Root of all queries. */
export type QueryRootTv_App_Title_Detail_PageArgs = {
  slug: Scalars['String']['input'];
};


/** Root of all queries. */
export type QueryRootUser_GiftsArgs = {
  owner: Scalars['String']['input'];
};

export type Active_Subscription = {
  __typename?: 'active_subscription';
  cancel_at_cycle_end?: Maybe<Scalars['Boolean']['output']>;
  cycle_started_at: Scalars['String']['output'];
  gateway_code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_payment_operation: Payment_Operation;
  last_transaction: Transaction;
  next_cycle_at: Scalars['String']['output'];
  recurrency_period: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscription_plan: Subscription_Plan;
  type: Scalars['String']['output'];
};

export type Ad_Data = {
  __typename?: 'ad_data';
  file_hash: Scalars['String']['output'];
  skippable_after_seconds?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type Ad_Event_Input = {
  ad_file_hash: Scalars['String']['input'];
};

export type Adaptive_Sources = {
  __typename?: 'adaptive_sources';
  dash?: Maybe<Scalars['String']['output']>;
  hls?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'address';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  district: Scalars['String']['output'];
  id: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type Address_Input = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  district: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postal_code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type App_Aspect_Ratio = {
  __typename?: 'app_aspect_ratio';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type App_Category_Bff = {
  __typename?: 'app_category_bff';
  content: Array<App_Content_Bff>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type App_Comment = {
  __typename?: 'app_comment';
  author: Scalars['String']['output'];
  content: Scalars['String']['output'];
  elapsed: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_mine: Scalars['Boolean']['output'];
};

export type App_Comment_Create_Input = {
  content: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
};

export type App_Comment_Create_Response = App_Comment | Catalog_Error;

export type App_Comment_Delete_Input = {
  id: Scalars['Int']['input'];
};

export type App_Comment_Delete_Response = App_Comment_Delete_Result | Catalog_Error;

export type App_Comment_Delete_Result = {
  __typename?: 'app_comment_delete_result';
  deleted: Scalars['Int']['output'];
};

export type App_Comment_Get_Response = App_Comment_Get_Result | Catalog_Error;

export type App_Comment_Get_Result = {
  __typename?: 'app_comment_get_result';
  data: Array<App_Comment>;
  has_next: Scalars['Boolean']['output'];
  last_post?: Maybe<Scalars['Int']['output']>;
};

export type App_Content_Bff = {
  __typename?: 'app_content_bff';
  allowed: Scalars['Boolean']['output'];
  checkpoint?: Maybe<Scalars['Float']['output']>;
  duration: Scalars['Float']['output'];
  dvd?: Maybe<Scalars['String']['output']>;
  fifty_one_sixty?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  media_id?: Maybe<Scalars['String']['output']>;
  playlist_id: Scalars['String']['output'];
  playlist_name: Scalars['String']['output'];
  playlist_slug: Scalars['String']['output'];
  selected_thumbnail?: Maybe<Selected_Thumbnail>;
  sixteen_nine?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnails?: Maybe<Thumbnails>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type App_Home = {
  __typename?: 'app_home';
  banner: App_Home_Banner;
  categories: Array<Category>;
  keep_watching: Array<Playlist>;
};

export type App_Home_Banner = {
  __typename?: 'app_home_banner';
  background_image: Image;
  content_description: Scalars['String']['output'];
  content_image?: Maybe<Image>;
  content_title?: Maybe<Scalars['String']['output']>;
  playlist_id: Scalars['String']['output'];
  playlist_type: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type App_Image = {
  __typename?: 'app_image';
  alt?: Maybe<Scalars['String']['output']>;
  aspect_ratio?: Maybe<App_Aspect_Ratio>;
  path: Scalars['String']['output'];
};

export type App_Page_Bff = {
  __typename?: 'app_page_bff';
  categories: Array<App_Category_Bff>;
  highlights?: Maybe<App_Category_Bff>;
  invite_friend_card?: Maybe<Invite_Friend_Card>;
};

export type Aspect_Ratio = {
  __typename?: 'aspect_ratio';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type Audio = {
  __typename?: 'audio';
  embed: Scalars['String']['output'];
  id: Scalars['String']['output'];
  raw_sources: Array<Raw_Source>;
  slug: Scalars['String']['output'];
};

export type Auditorium_Bff = {
  __typename?: 'auditorium_bff';
  event_metadata?: Maybe<Bff_Metadata>;
  menu: Bff_Menu;
  pages: Array<Bff_Page>;
};

export type Auth = {
  __typename?: 'auth';
  refresh: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type Authorization = {
  __typename?: 'authorization';
  authorization_code: Scalars['String']['output'];
};

export type Authorization_Input = {
  client_id: Scalars['String']['input'];
  redirect_uri: Scalars['String']['input'];
  response_type: Scalars['String']['input'];
  scope: Array<Scalars['String']['input']>;
};

export type Authorization_Response = Authorization | Error;

export type Available_Offer = {
  __typename?: 'available_offer';
  discount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type Available_Product_Changes = {
  __typename?: 'available_product_changes';
  best?: Maybe<Available_Offer>;
  better?: Maybe<Available_Offer>;
  good?: Maybe<Available_Offer>;
  supporter?: Maybe<Available_Offer>;
};

export type Available_Product_Changes_Either = Available_Product_Changes | Error;

export type Badge_Icon = {
  __typename?: 'badge_icon';
  png: Scalars['String']['output'];
};

export type Badges = {
  __typename?: 'badges';
  active: Scalars['Boolean']['output'];
  badge: Scalars['String']['output'];
  color: Scalars['String']['output'];
  icon?: Maybe<Badge_Icon>;
  name: Scalars['String']['output'];
};

export type Banner = {
  __typename?: 'banner';
  button: Button;
  description?: Maybe<Scalars['String']['output']>;
  image: Image;
  label?: Maybe<Label>;
  logo?: Maybe<Image>;
  metadata?: Maybe<Banner_Metadata>;
  mobile_image: Image;
  my_bp: Scalars['Boolean']['output'];
  playlist_id: Scalars['String']['output'];
  second_button?: Maybe<Button>;
  shareable_info?: Maybe<Shareable_Info>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Banner_Metadata = {
  __typename?: 'banner_metadata';
  cast?: Maybe<Scalars['String']['output']>;
  min_age?: Maybe<Min_Age>;
  schedule?: Maybe<Scalars['String']['output']>;
};

export type Bff_Banner = {
  __typename?: 'bff_banner';
  btns: Array<Bff_Banner_Btn>;
  description: Scalars['String']['output'];
  extra?: Maybe<Scalars['String']['output']>;
  img: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Bff_Banner_Btn = {
  __typename?: 'bff_banner_btn';
  event: Scalars['String']['output'];
  label: Scalars['String']['output'];
  style: Scalars['String']['output'];
};

export type Bff_Card = {
  __typename?: 'bff_card';
  allowed: Scalars['Boolean']['output'];
  card_filter?: Maybe<Scalars['String']['output']>;
  card_metadata?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  html_metadata?: Maybe<Scalars['String']['output']>;
  img: Scalars['String']['output'];
  teacher?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Bff_Club = {
  __typename?: 'bff_club';
  bg: Scalars['String']['output'];
  event: Scalars['String']['output'];
  logo: Bff_Club_Logo;
};

export type Bff_Club_Logo = {
  __typename?: 'bff_club_logo';
  black: Scalars['String']['output'];
  white: Scalars['String']['output'];
};

export type Bff_Filter = {
  __typename?: 'bff_filter';
  label: Scalars['String']['output'];
};

/** Informally known as clubão */
export type Bff_Filterable_Club = {
  __typename?: 'bff_filterable_club';
  course_cards: Array<Bff_Card>;
  filters: Array<Bff_Filter>;
  logo: Scalars['String']['output'];
};

export type Bff_Home_Like = {
  __typename?: 'bff_home_like';
  banner: Bff_Banner;
  sections: Array<Bff_Section>;
};

export type Bff_Menu = {
  __typename?: 'bff_menu';
  items: Array<Bff_Menu_Item>;
};

export type Bff_Menu_Item = {
  __typename?: 'bff_menu_item';
  event: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Bff_Metadata = {
  __typename?: 'bff_metadata';
  virtual_playlists: Array<Bff_Virtual_Playlist>;
};

export type Bff_Mob_Desk_String = {
  __typename?: 'bff_mob_desk_string';
  desktop?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

export type Bff_Page = {
  __typename?: 'bff_page';
  content: Bff_Page_Content;
  page_id: Scalars['String']['output'];
};

export type Bff_Page_Content = Bff_Filterable_Club | Bff_Home_Like | Bff_Pillars | Bff_Productions_Like | Bff_Small_Club;

export type Bff_Pillars = {
  __typename?: 'bff_pillars';
  clubs: Array<Bff_Club>;
};

export type Bff_Productions_Like = {
  __typename?: 'bff_productions_like';
  sections: Array<Bff_Section>;
  title: Scalars['String']['output'];
};

export type Bff_Section = {
  __typename?: 'bff_section';
  cards: Array<Bff_Card>;
  thumb_h: Scalars['Int']['output'];
  thumb_w: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Informally known as clubinho */
export type Bff_Small_Club = {
  __typename?: 'bff_small_club';
  course_cards: Array<Bff_Card>;
  logo: Scalars['String']['output'];
};

export type Bff_Virtual_Playlist = {
  __typename?: 'bff_virtual_playlist';
  id: Scalars['String']['output'];
  medias: Array<Bff_Virtual_Playlist_Media>;
};

export type Bff_Virtual_Playlist_Media = {
  __typename?: 'bff_virtual_playlist_media';
  id: Scalars['String']['output'];
  source_playlist: Bff_Virtual_Playlist_Media_Source_Playlist;
};

export type Bff_Virtual_Playlist_Media_Source_Playlist = {
  __typename?: 'bff_virtual_playlist_media_source_playlist';
  id: Scalars['String']['output'];
  media: Scalars['String']['output'];
};

export type Billet = {
  __typename?: 'billet';
  expiration_date: Scalars['String']['output'];
  line: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Button = {
  __typename?: 'button';
  colors?: Maybe<Component_Colors>;
  link?: Maybe<Scalars['String']['output']>;
  playlist_slug?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Button_Clicked_Input = {
  component_id: Scalars['String']['input'];
  live_id?: InputMaybe<Scalars['String']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  playlist_id?: InputMaybe<Scalars['String']['input']>;
  view: Scalars['String']['input'];
};

export type Button_Language_Settings = {
  __typename?: 'button_language_settings';
  audio: Scalars['String']['output'];
  subtitles: Scalars['String']['output'];
};

export type Campaign_Register_Input = {
  campaign: Scalars['String']['input'];
};

export type Cancel_Subscription_Input = {
  cancel_reason: Scalars['String']['input'];
  gateway_code: Scalars['String']['input'];
};

export type Castle = {
  __typename?: 'castle';
  categories: Array<Category>;
  main_banner: Banner;
  products: Array<Castle_Product>;
};

export type Castle_Product = {
  __typename?: 'castle_product';
  slug: Scalars['String']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type Catalog_Card = {
  __typename?: 'catalog_card';
  allowed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mobile_thumbnail: App_Image;
  progress: Product_Progress;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail: App_Image;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Catalog_Error = {
  __typename?: 'catalog_error';
  error_type: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'category';
  category: Scalars['String']['output'];
  id: Scalars['String']['output'];
  medias?: Maybe<Array<Media>>;
  playlists?: Maybe<Array<Playlist>>;
};

export type Certification_Info = {
  __typename?: 'certification_info';
  certification_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  post_script?: Maybe<Scalars['String']['output']>;
  progress: Product_Progress;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Change_Payment_Settings_Input = {
  credit_card?: InputMaybe<Scalars['String']['input']>;
  gateway_code: Scalars['String']['input'];
  installments?: InputMaybe<Scalars['Int']['input']>;
  payment_method: Scalars['String']['input'];
};

export type Change_Product_Input = {
  gateway_code: Scalars['String']['input'];
  offer_id: Scalars['String']['input'];
};

export type Check_Reset_Token_Input = {
  reset_token: Scalars['String']['input'];
};

export type Check_Reset_Token_Response = {
  __typename?: 'check_reset_token_response';
  email: Scalars['String']['output'];
  reset_token: Scalars['String']['output'];
};

export type Collapse_Section = {
  __typename?: 'collapse_section';
  items: Array<Catalog_Card>;
  progress: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'comment';
  author: Comment_Author;
  created_at: Scalars['String']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  media: Scalars['String']['output'];
  parent?: Maybe<Parent>;
  replies: Array<Comment>;
  shadowed?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  v: Scalars['Int']['output'];
};

export type Comment_Author = {
  __typename?: 'comment_author';
  avatar: Image;
  badge: Scalars['String']['output'];
  badges?: Maybe<Array<Badges>>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Scalars['String']['output']>>;
};

export type Comment_Disclaimer_Input = {
  id: Scalars['String']['input'];
  show_comments_disclaimer: Scalars['Boolean']['input'];
};

export type Comment_Input = {
  media: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type Comment_Shadow_Input = {
  id: Scalars['String']['input'];
};

export type Comments = {
  __typename?: 'comments';
  allowed: Scalars['Boolean']['output'];
  docs: Array<Comment>;
  has_next_page: Scalars['Boolean']['output'];
  has_prev_page: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  next_page?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  paging_counter: Scalars['Int']['output'];
  prev_page?: Maybe<Scalars['Int']['output']>;
  total_docs: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type Comments_Info = {
  __typename?: 'comments_info';
  policy: Scalars['String']['output'];
};

export type Component_Color_States = {
  __typename?: 'component_color_states';
  hover: Scalars['String']['output'];
  normal: Scalars['String']['output'];
};

export type Component_Colors = {
  __typename?: 'component_colors';
  background?: Maybe<Scalars['String']['output']>;
  border?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Config = {
  __typename?: 'config';
  features: Features;
  hebe_redirect_forbidden_hosts: Array<Scalars['String']['output']>;
  hebe_sentry_error_sample_rate: Scalars['Float']['output'];
  hebe_sentry_traces_sample_rate: Scalars['Float']['output'];
  min_app_version: Scalars['String']['output'];
};

export type Content = {
  __typename?: 'content';
  id: Scalars['String']['output'];
};

export type Content_Review_Update_Media_Input = {
  media_id: Scalars['String']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
};

export type Content_Review_Update_Media_Response = Content_Review_Update_Media_Success | Error;

export type Content_Review_Update_Media_Success = {
  __typename?: 'content_review_update_media_success';
  media_id: Scalars['String']['output'];
  review?: Maybe<Scalars['String']['output']>;
};

export type Content_Review_Update_Title_Input = {
  review?: InputMaybe<Scalars['String']['input']>;
  title_id: Scalars['String']['input'];
};

export type Content_Review_Update_Title_Response = Content_Review_Update_Title_Success | Error;

export type Content_Review_Update_Title_Success = {
  __typename?: 'content_review_update_title_success';
  review?: Maybe<Scalars['String']['output']>;
  title_id: Scalars['String']['output'];
};

export type Cookies = {
  __typename?: 'cookies';
  rcl_consent_given?: Maybe<Scalars['Boolean']['output']>;
  rcl_marketing_consent?: Maybe<Scalars['Boolean']['output']>;
  rcl_preferences_consent?: Maybe<Scalars['Boolean']['output']>;
  rcl_statistics_consent?: Maybe<Scalars['Boolean']['output']>;
};

export type Cookies_Input = {
  rcl_consent_given: Scalars['Boolean']['input'];
  rcl_marketing_consent: Scalars['Boolean']['input'];
  rcl_preferences_consent: Scalars['Boolean']['input'];
  rcl_statistics_consent: Scalars['Boolean']['input'];
};

export type Create_Comment_Either = Comment | Error;

export type Create_Free_Member_Response = Create_Free_Member_Success | Error;

export type Create_Free_Member_Success = {
  __typename?: 'create_free_member_success';
  password_definition_link: Scalars['String']['output'];
  password_reset_token: Scalars['String']['output'];
};

export type Credit_Card = {
  __typename?: 'credit_card';
  brand: Scalars['String']['output'];
  first_digits?: Maybe<Scalars['String']['output']>;
  installments?: Maybe<Scalars['Int']['output']>;
  last_digits: Scalars['String']['output'];
};

export type Delete_Comment_Input = {
  id: Scalars['String']['input'];
};

export type Deprecated_Subscription = {
  __typename?: 'deprecated_subscription';
  access_since: Scalars['String']['output'];
  access_type: Scalars['String']['output'];
  access_until: Scalars['String']['output'];
  cancel_at_cycle_end?: Maybe<Scalars['Boolean']['output']>;
  cancel_reason: Scalars['String']['output'];
  canceled_at: Scalars['String']['output'];
  card?: Maybe<Credit_Card>;
  card_editable: Scalars['Boolean']['output'];
  cycle_started_at: Scalars['String']['output'];
  gateway_code: Scalars['String']['output'];
  gateway_name: Scalars['String']['output'];
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_payment_operation: Payment_Operation;
  last_transaction: Transaction;
  next_cycle_at: Scalars['String']['output'];
  recurrency_period: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscription_plan: Subscription_Plan;
  type: Scalars['String']['output'];
};

export type Device_Handling_Input = {
  app_version: Scalars['String']['input'];
  device: Scalars['String']['input'];
  device_id: Scalars['String']['input'];
  os: Scalars['String']['input'];
  os_version: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type Discount = {
  __typename?: 'discount';
  amount?: Maybe<Scalars['Int']['output']>;
  cents_amount: Scalars['Int']['output'];
  cycles?: Maybe<Scalars['Int']['output']>;
};

export type Download_License_Permission = {
  __typename?: 'download_license_permission';
  allowed: Scalars['Boolean']['output'];
  error?: Maybe<Download_Permission_Error_Message>;
};

export type Download_Permission_Error_Message = {
  __typename?: 'download_permission_error_message';
  error_type?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Downloads_List = {
  __typename?: 'downloads_list';
  downloads: Array<Scalars['String']['output']>;
};

export type Drm_License = Error | License;

export type Drm_Params = {
  __typename?: 'drm_params';
  technology: Scalars['String']['output'];
};

export type Edit_Comment = {
  __typename?: 'edit_comment';
  result: Scalars['String']['output'];
};

export type Edit_Comment_Either = Edit_Comment | Error;

export type Edit_Comment_Input = {
  id: Scalars['String']['input'];
  new_text: Scalars['String']['input'];
};

export type Error = {
  __typename?: 'error';
  code: Scalars['Int']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Event_Mutation_Response = {
  __typename?: 'event_mutation_response';
  success: Scalars['Boolean']['output'];
};

export type Feature_Flag = {
  __typename?: 'feature_flag';
  enabled: Scalars['Boolean']['output'];
};

export type Features = {
  __typename?: 'features';
  checkpoint_interval_ms: Scalars['Int']['output'];
  clube_da_musica: Scalars['Boolean']['output'];
  comments: Scalars['Boolean']['output'];
  comments_report_button_mobile: Scalars['Boolean']['output'];
  content_rating: Scalars['Boolean']['output'];
  delete_account: Scalars['Boolean']['output'];
  download_on_media_screen: Scalars['Boolean']['output'];
  drm_on_mobile: Scalars['Boolean']['output'];
  feat_stories_android_min_sdk_version: Scalars['Int']['output'];
  feat_stories_enabled: Scalars['Boolean']['output'];
  feat_stories_test_mode_enabled: Scalars['Boolean']['output'];
  hebe_redirect: Scalars['Boolean']['output'];
  hebe_show_language_controls: Scalars['Boolean']['output'];
  hebe_use_fancy_subtitles_displayer: Scalars['Boolean']['output'];
  lives: Scalars['Boolean']['output'];
  login_purchase_flow_android: Scalars['Boolean']['output'];
  login_purchase_flow_ios: Scalars['Boolean']['output'];
  multiscreen_checking_mobile: Scalars['Boolean']['output'];
  my_bp: Scalars['Boolean']['output'];
  new_player_android: Scalars['Boolean']['output'];
  new_player_ios: Scalars['Boolean']['output'];
  offline_playback_android_enabled: Scalars['Boolean']['output'];
  offline_playback_ios_enabled: Scalars['Boolean']['output'];
  qr_code_login_mobile: Scalars['Boolean']['output'];
  show_programs: Scalars['Boolean']['output'];
  show_reset_password_button: Scalars['Boolean']['output'];
  show_ribbon_android: Scalars['Boolean']['output'];
  show_ribbon_ios: Scalars['Boolean']['output'];
  show_shorts: Scalars['Boolean']['output'];
  skip_multi_screen_validation: Scalars['Boolean']['output'];
  subscription_management: Scalars['Boolean']['output'];
  upsell: Scalars['Boolean']['output'];
  use_offline_reproduction_flow_when_online: Scalars['Boolean']['output'];
};

export type Forgot_Password_Input = {
  email: Scalars['String']['input'];
};

export type Free_Member_Input = {
  campaign?: InputMaybe<Freemium_Campaign_Input>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type Freemium_Campaign_Input = {
  dt_visit: Scalars['String']['input'];
  lead_slug: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  url: Scalars['String']['input'];
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type Freemium_Offer = {
  __typename?: 'freemium_offer';
  banner: Freemium_Offer_Banner;
  countdown: Freemium_Offer_Countdown;
  cta: Freemium_Offer_Cta;
  unlock_content_modal: Freemium_Offer_Unlock_Content_Modal;
};

export type Freemium_Offer_Banner = {
  __typename?: 'freemium_offer_banner';
  colors: Freemium_Offer_Banner_Colors;
  header: Scalars['String']['output'];
  subheader: Scalars['String']['output'];
};

export type Freemium_Offer_Banner_Colors = {
  __typename?: 'freemium_offer_banner_colors';
  background: Bff_Mob_Desk_String;
  text: Scalars['String']['output'];
};

export type Freemium_Offer_Countdown = {
  __typename?: 'freemium_offer_countdown';
  end_date: Scalars['String']['output'];
  labels: Freemium_Offer_Countdown_Labels;
  text: Freemium_Offer_Countdown_Text;
};

export type Freemium_Offer_Countdown_Labels = {
  __typename?: 'freemium_offer_countdown_labels';
  colors: Component_Colors;
};

export type Freemium_Offer_Countdown_Text = {
  __typename?: 'freemium_offer_countdown_text';
  colors: Component_Colors;
};

export type Freemium_Offer_Cta = {
  __typename?: 'freemium_offer_cta';
  colors: Freemium_Offer_Cta_Colors;
  link: Scalars['String']['output'];
  text: Freemium_Offer_Cta_Text;
};

export type Freemium_Offer_Cta_Colors = {
  __typename?: 'freemium_offer_cta_colors';
  background: Component_Color_States;
  text: Component_Color_States;
};

export type Freemium_Offer_Cta_Text = {
  __typename?: 'freemium_offer_cta_text';
  desktop: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
};

export type Freemium_Offer_Unlock_Content_Modal = {
  __typename?: 'freemium_offer_unlock_content_modal';
  header: Scalars['String']['output'];
  subheader: Scalars['String']['output'];
};

export type General_Info = {
  __typename?: 'general_info';
  comments: Comments_Info;
};

export type Gift_Card = {
  __typename?: 'gift_card';
  activation: Gift_Card_Activation;
  expiration: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscription: Gift_Card_Subscription;
  token: Scalars['String']['output'];
};

export type Gift_Card_Activation = {
  __typename?: 'gift_card_activation';
  activated_at: Scalars['String']['output'];
  user: Gift_Card_User;
};

export type Gift_Card_Subscription = {
  __typename?: 'gift_card_subscription';
  access_period: Scalars['Int']['output'];
  plan: Subscription_Plan;
};

export type Gift_Card_User = {
  __typename?: 'gift_card_user';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'image';
  image: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Instagram_Data = {
  __typename?: 'instagram_data';
  image_url?: Maybe<Scalars['String']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};

export type Installments = {
  __typename?: 'installments';
  interest?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Interactions_Info = {
  __typename?: 'interactions_info';
  user_tracking_id?: Maybe<Scalars['String']['output']>;
};

export type Invite_Friend_Card = {
  __typename?: 'invite_friend_card';
  title: Scalars['String']['output'];
};

export type Label = {
  __typename?: 'label';
  colors: Component_Colors;
  icon: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Last_Operation = {
  __typename?: 'last_operation';
  operation_name: Scalars['String']['output'];
  operation_status?: Maybe<Scalars['String']['output']>;
  received_at?: Maybe<Scalars['String']['output']>;
  support_automatic_refund?: Maybe<Scalars['Boolean']['output']>;
};

export type Last_Transaction = {
  __typename?: 'last_transaction';
  created_at: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan: Scalars['String']['output'];
};

export type Latest = {
  __typename?: 'latest';
  live_with_raw_sources: Playlist;
  serie: Playlist;
};

export type Level = {
  __typename?: 'level';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type License = {
  __typename?: 'license';
  license: Scalars['String']['output'];
};

export type List_Item_Clicked_Input = {
  component_id: Scalars['String']['input'];
  component_pos: Scalars['Int']['input'];
  item_pos: Scalars['Int']['input'];
  live_id?: InputMaybe<Scalars['String']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  playlist_id?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  view: Scalars['String']['input'];
};

export type Live = {
  __typename?: 'live';
  banner: Thumb;
  cta_label?: Maybe<Scalars['String']['output']>;
  cta_link?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  ended_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  live_sse_url: Scalars['String']['output'];
  mux_playback_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  schedule_time: Scalars['String']['output'];
  started_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  thumb: Thumb;
  time_label: Scalars['String']['output'];
};

export type Login = Auth | Error;

export type Login_Input = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Manifest = {
  __typename?: 'manifest';
  drm?: Maybe<Drm_Params>;
  skd: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Material = {
  __typename?: 'material';
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Media = {
  __typename?: 'media';
  ad?: Maybe<Ad_Data>;
  adaptive_sources?: Maybe<Adaptive_Sources>;
  allowed: Scalars['Boolean']['output'];
  bibliography?: Maybe<Scalars['String']['output']>;
  checkpoint: Scalars['Float']['output'];
  completed: Scalars['Boolean']['output'];
  content_review?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  credits_start_seconds?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  download_manifest: Manifest;
  duration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  intro_end_seconds?: Maybe<Scalars['Int']['output']>;
  intro_start_seconds?: Maybe<Scalars['Int']['output']>;
  is_movie_intro?: Maybe<Scalars['Boolean']['output']>;
  live_end?: Maybe<Scalars['String']['output']>;
  live_now?: Maybe<Scalars['Boolean']['output']>;
  live_start?: Maybe<Scalars['String']['output']>;
  manifest: Manifest;
  materials?: Maybe<Array<Material>>;
  media: Scalars['String']['output'];
  my_bp_added: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  next_media?: Maybe<Scalars['String']['output']>;
  next_media_for_player?: Maybe<Media>;
  next_media_object?: Maybe<Media>;
  parental_permitted: Scalars['Boolean']['output'];
  playlist: Playlist;
  rating?: Maybe<Media_Rating>;
  raw_sources: Array<Raw_Source>;
  related_content?: Maybe<Related_Content>;
  resource?: Maybe<Media_Resource>;
  shareable_info: Shareable_Info;
  source?: Maybe<Source>;
  source_url?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  thumbnail?: Maybe<Image>;
  youtube_id?: Maybe<Scalars['String']['output']>;
};


export type MediaDownload_ManifestArgs = {
  type: Scalars['String']['input'];
};


export type MediaManifestArgs = {
  type: Scalars['String']['input'];
};


export type MediaResourceArgs = {
  hdcp?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
};

export type Media_Rating = {
  __typename?: 'media_rating';
  advisory: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Media_Resource = {
  __typename?: 'media_resource';
  drm?: Maybe<Drm_Params>;
  session_token: Scalars['String']['output'];
  skd: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Media_Type = {
  __typename?: 'media_type';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Migrate_Token_Input = {
  token: Scalars['String']['input'];
};

export type Min_Age = {
  __typename?: 'min_age';
  age: Scalars['String']['output'];
  color: Scalars['String']['output'];
};

export type Mobile_App_Action = Mobile_App_Add_My_Bp_Title | Mobile_App_Navigate_To_Route | Mobile_App_Navigate_To_Url | Mobile_App_Share_Content | Mobile_App_Show_Paywall;

export type Mobile_App_Action_Bar = {
  __typename?: 'mobile_app_action_bar';
  primary?: Maybe<Mobile_App_Button>;
  secondary?: Maybe<Array<Mobile_App_Button>>;
};

export type Mobile_App_Add_My_Bp_Title = {
  __typename?: 'mobile_app_add_my_bp_title';
  new_value: Scalars['Boolean']['output'];
  title_id: Scalars['String']['output'];
};

export type Mobile_App_Badge = {
  __typename?: 'mobile_app_badge';
  background_color: Mobile_App_Color;
  /** Value can be 'sm' (small), 'md' (medium) or 'lg' (large). */
  size: Scalars['String']['output'];
  /** Value can be 'pill' or 'modern'. */
  style: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Mobile_App_Button = {
  __typename?: 'mobile_app_button';
  action?: Maybe<Mobile_App_Action>;
  /** Additional data. Clients should parse this string as a JSON. */
  data?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** Value can be "horizontal" or "vertical". */
  orientation?: Maybe<Scalars['String']['output']>;
  parent_view?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  selected_action?: Maybe<Mobile_App_Action>;
  selected_icon?: Maybe<Scalars['String']['output']>;
  selected_label?: Maybe<Scalars['String']['output']>;
  /** Value can be "sm", "md" or "lg". */
  size?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type Mobile_App_Can_Download = Mobile_App_Can_Download_Media | Mobile_App_Error;

export type Mobile_App_Can_Download_Media = {
  __typename?: 'mobile_app_can_download_media';
  allowed: Scalars['Boolean']['output'];
  reason?: Maybe<Mobile_App_Can_Download_Media_Reason>;
};

export type Mobile_App_Can_Download_Media_Reason = {
  __typename?: 'mobile_app_can_download_media_reason';
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Mobile_App_Card = Mobile_App_Landscape_Card | Mobile_App_Poster_Card | Mobile_App_Primary_Highlight_Card | Mobile_App_Secondary_Highlight_Card | Mobile_App_Thumb_List_Media | Mobile_App_Thumb_Title_Landscape_Card;

export type Mobile_App_Carousel = {
  __typename?: 'mobile_app_carousel';
  auto_scroll?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  infinite_scroll?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Mobile_App_Card>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailing?: Maybe<Mobile_App_Button>;
};

export type Mobile_App_Cast_Standby_Item = {
  __typename?: 'mobile_app_cast_standby_item';
  background_image: Scalars['String']['output'];
  description: Scalars['String']['output'];
  details: Scalars['String']['output'];
  directors: Array<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  rating_image: Scalars['String']['output'];
};

export type Mobile_App_Cast_Standby_Page = {
  __typename?: 'mobile_app_cast_standby_page';
  items: Array<Mobile_App_Cast_Standby_Item>;
};

export type Mobile_App_Cast_Standby_Page_Response = Mobile_App_Cast_Standby_Page | Mobile_App_Error;

export type Mobile_App_Color = {
  __typename?: 'mobile_app_color';
  blue: Scalars['Int']['output'];
  green: Scalars['Int']['output'];
  opacity: Scalars['Float']['output'];
  red: Scalars['Int']['output'];
};

export type Mobile_App_Component = Mobile_App_Carousel | Mobile_App_Highlights | Mobile_App_Live_Pill | Mobile_App_My_Bp_Empty_Component | Mobile_App_Primary_Highlights | Mobile_App_Storytelling;

export type Mobile_App_Download_Limit = {
  __typename?: 'mobile_app_download_limit';
  can_upgrade: Scalars['Boolean']['output'];
  user_limit: Scalars['Int']['output'];
};

export type Mobile_App_Error = {
  __typename?: 'mobile_app_error';
  error_type: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Mobile_App_Highlight_Card = {
  __typename?: 'mobile_app_highlight_card';
  action: Mobile_App_Action;
  id: Scalars['String']['output'];
  landscape_thumbnail: Mobile_App_Thumbnail;
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  original_icon?: Maybe<Scalars['Boolean']['output']>;
  poster_thumbnail: Mobile_App_Thumbnail;
};

export type Mobile_App_Highlights = {
  __typename?: 'mobile_app_highlights';
  items: Array<Mobile_App_Highlight_Card>;
};

export type Mobile_App_Landscape_Card = {
  __typename?: 'mobile_app_landscape_card';
  action: Mobile_App_Action;
  badges?: Maybe<Array<Mobile_App_Badge>>;
  bottom_subtitle?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  formatted_duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  original_icon?: Maybe<Scalars['Boolean']['output']>;
  play_icon: Scalars['Boolean']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  /** Value can be 'S' (small), 'M' (medium) or 'L' (large). */
  size?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail: Mobile_App_Thumbnail;
  title?: Maybe<Scalars['String']['output']>;
};

export type Mobile_App_List_Page = Mobile_App_Error | Mobile_App_List_Page_Content;

export type Mobile_App_List_Page_Content = {
  __typename?: 'mobile_app_list_page_content';
  components: Array<Mobile_App_Component>;
};

export type Mobile_App_Live_Details_Page = {
  __typename?: 'mobile_app_live_details_page';
  description: Scalars['String']['output'];
  /** SSE server URL to get real-time updates for this live metadata. If null, then the live status is probably finished. */
  event_source_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** If null, then live status is probably idle. */
  playback_url?: Maybe<Scalars['String']['output']>;
  primary_button?: Maybe<Mobile_App_Button>;
  /** A timestamp with timezone info. Example: "2025-11-12 20:00:00-03", which corresponds to 8 PM in Brasília (UTC-3). */
  schedule_date: Scalars['String']['output'];
  /** A timestamp with timezone info. Example: "2025-11-12 20:00:00-03", which corresponds to 8 PM in Brasília (UTC-3). */
  started_at?: Maybe<Scalars['String']['output']>;
  /** Live status can be "idle" (created, but not started yet), "active" (started, live ON), or "finished" (live completed, may be avaliable to reprise). */
  status: Scalars['String']['output'];
  thumbnail_url: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Mobile_App_Live_Details_Page_Response = Mobile_App_Error | Mobile_App_Live_Details_Page;

export type Mobile_App_Live_Pill = {
  __typename?: 'mobile_app_live_pill';
  action: Mobile_App_Action;
  badge: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Mobile_App_My_Bp_Empty_Component = {
  __typename?: 'mobile_app_my_bp_empty_component';
  icon: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Mobile_App_My_Bp_Medias_Page = {
  __typename?: 'mobile_app_my_bp_medias_page';
  medias: Array<Mobile_App_Responsive_Card>;
};

export type Mobile_App_My_Bp_Medias_Page_Response = Mobile_App_Error | Mobile_App_My_Bp_Medias_Page;

export type Mobile_App_My_Bp_Page = {
  __typename?: 'mobile_app_my_bp_page';
  components: Array<Mobile_App_Component>;
};

export type Mobile_App_My_Bp_Page_Response = Mobile_App_Error | Mobile_App_My_Bp_Page;

export type Mobile_App_My_Bp_Titles_Page = {
  __typename?: 'mobile_app_my_bp_titles_page';
  titles: Array<Mobile_App_Responsive_Card>;
};

export type Mobile_App_My_Bp_Titles_Page_Response = Mobile_App_Error | Mobile_App_My_Bp_Titles_Page;

export type Mobile_App_Navigate_To_Route = {
  __typename?: 'mobile_app_navigate_to_route';
  path: Scalars['String']['output'];
};

export type Mobile_App_Navigate_To_Url = {
  __typename?: 'mobile_app_navigate_to_url';
  url: Scalars['String']['output'];
};

export type Mobile_App_Poster_Card = {
  __typename?: 'mobile_app_poster_card';
  action: Mobile_App_Action;
  card_size: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  original_icon?: Maybe<Scalars['Boolean']['output']>;
  play_icon: Scalars['Boolean']['output'];
  thumbnail: Mobile_App_Thumbnail;
};

export type Mobile_App_Primary_Highlight_Card = {
  __typename?: 'mobile_app_primary_highlight_card';
  action?: Maybe<Mobile_App_Action>;
  action_bar?: Maybe<Mobile_App_Action_Bar>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  landscape_background_image: Mobile_App_Thumbnail;
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  original_icon?: Maybe<Scalars['Boolean']['output']>;
  portrait_background_image: Mobile_App_Thumbnail;
  tags?: Maybe<Scalars['String']['output']>;
};

export type Mobile_App_Primary_Highlights = {
  __typename?: 'mobile_app_primary_highlights';
  auto_scroll?: Maybe<Scalars['Boolean']['output']>;
  infinite_scroll?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Mobile_App_Primary_Highlight_Card>;
};

export type Mobile_App_Responsive_Card = {
  __typename?: 'mobile_app_responsive_card';
  compact: Mobile_App_Card;
  expanded?: Maybe<Mobile_App_Card>;
  extra_large?: Maybe<Mobile_App_Card>;
  large?: Maybe<Mobile_App_Card>;
  medium?: Maybe<Mobile_App_Card>;
};

export type Mobile_App_Secondary_Highlight_Card = {
  __typename?: 'mobile_app_secondary_highlight_card';
  action: Mobile_App_Action;
  background_image: Mobile_App_Thumbnail;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  original_icon?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
};

export type Mobile_App_Share_Campaign_Colors = {
  __typename?: 'mobile_app_share_campaign_colors';
  overlay_color: Mobile_App_Color;
  radial_end_color: Mobile_App_Color;
  radial_start_color: Mobile_App_Color;
};

export type Mobile_App_Share_Content = {
  __typename?: 'mobile_app_share_content';
  content_id: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  direct_message_text: Scalars['String']['output'];
  hashtags: Array<Scalars['String']['output']>;
  public_text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Mobile_App_Share_Data = {
  __typename?: 'mobile_app_share_data';
  content_id: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  direct_message_text: Scalars['String']['output'];
  hashtags: Array<Scalars['String']['output']>;
  instagram_data?: Maybe<Mobile_App_Share_Instagram_Data>;
  media_name?: Maybe<Scalars['String']['output']>;
  playlist_name?: Maybe<Scalars['String']['output']>;
  public_text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Mobile_App_Share_Instagram_Data = {
  __typename?: 'mobile_app_share_instagram_data';
  image_url?: Maybe<Scalars['String']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};

export type Mobile_App_Show_Paywall = {
  __typename?: 'mobile_app_show_paywall';
  media_id: Scalars['String']['output'];
  playlist_type: Scalars['String']['output'];
};

export type Mobile_App_Storytelling = {
  __typename?: 'mobile_app_storytelling';
  /** Deprecated. Use primary-button instead. Can be removed when minimum mobile app version gets to 6.12.0 or above. */
  action: Mobile_App_Action;
  logo_url: Scalars['String']['output'];
  playlist_id: Scalars['String']['output'];
  primary_button: Mobile_App_Button;
  share_campaign_colors?: Maybe<Mobile_App_Share_Campaign_Colors>;
  share_data?: Maybe<Mobile_App_Share_Data>;
  slides: Array<Mobile_App_Storytelling_Slide>;
};

export type Mobile_App_Storytelling_Cover_Slide = {
  __typename?: 'mobile_app_storytelling_cover_slide';
  background_gif_url?: Maybe<Scalars['String']['output']>;
  background_image_url: Scalars['String']['output'];
  header_text: Scalars['String']['output'];
  swipe_gif_url: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Mobile_App_Storytelling_Slide = Mobile_App_Storytelling_Cover_Slide | Mobile_App_Storytelling_Text_Slide;

export type Mobile_App_Storytelling_Text_Slide = {
  __typename?: 'mobile_app_storytelling_text_slide';
  background_gif_url?: Maybe<Scalars['String']['output']>;
  background_image_url: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Mobile_App_Thumb_Episode_Landscape = {
  __typename?: 'mobile_app_thumb_episode_landscape';
  action: Mobile_App_Action;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lock_icon: Scalars['Boolean']['output'];
  playlist_id: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail: Mobile_App_Thumbnail;
  title: Scalars['String']['output'];
};

/** Reference: https://www.figma.com/design/uQZijkkhfHYEYAhlAMFfhA/%E2%97%87-BPDS-Components?node-id=14096-10899&t=G9kdntVJyvPmSwci-4 */
export type Mobile_App_Thumb_List_Media = {
  __typename?: 'mobile_app_thumb_list_media';
  action: Mobile_App_Action;
  content_type: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lock_icon: Scalars['Boolean']['output'];
  original_icon: Scalars['Boolean']['output'];
  overtitle?: Maybe<Scalars['String']['output']>;
  play_icon: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail: Mobile_App_Thumbnail;
  title: Scalars['String']['output'];
};

export type Mobile_App_Thumb_Title_Landscape_Card = {
  __typename?: 'mobile_app_thumb_title_landscape_card';
  action: Mobile_App_Action;
  content_type: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  thumbnail: Mobile_App_Thumbnail;
  title: Scalars['String']['output'];
};

export type Mobile_App_Thumbnail = {
  __typename?: 'mobile_app_thumbnail';
  alt: Scalars['String']['output'];
  aspect_ratio?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page = {
  __typename?: 'mobile_app_title_details_page';
  background_image: Mobile_App_Thumbnail;
  checkpoint?: Maybe<Mobile_App_Title_Details_Page_Checkpoint>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  primary_button: Mobile_App_Button;
  secondary_buttons: Array<Mobile_App_Button>;
  subtitle: Mobile_App_Title_Details_Page_Subtitle;
  tabs: Array<Mobile_App_Title_Details_Page_Tab>;
  title: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Checkpoint = {
  __typename?: 'mobile_app_title_details_page_checkpoint';
  progress: Scalars['Float']['output'];
  time_left: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Material_Item = {
  __typename?: 'mobile_app_title_details_page_material_item';
  action: Mobile_App_Action;
  id: Scalars['String']['output'];
  overtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Materials_Section = {
  __typename?: 'mobile_app_title_details_page_materials_section';
  items: Array<Mobile_App_Title_Details_Page_Material_Item>;
  title: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Module = {
  __typename?: 'mobile_app_title_details_page_module';
  id: Scalars['String']['output'];
  items: Array<Mobile_App_Thumb_Episode_Landscape>;
  name: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Response = Mobile_App_Error | Mobile_App_Title_Details_Page;

export type Mobile_App_Title_Details_Page_Subtitle = {
  __typename?: 'mobile_app_title_details_page_subtitle';
  advisory_image_url: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Tab = Mobile_App_Title_Details_Page_Tab_Details | Mobile_App_Title_Details_Page_Tab_Episodes | Mobile_App_Title_Details_Page_Tab_Extras;

export type Mobile_App_Title_Details_Page_Tab_Details = {
  __typename?: 'mobile_app_title_details_page_tab_details';
  name: Scalars['String']['output'];
  sections: Array<Mobile_App_Title_Details_Page_Tab_Details_Section>;
};

export type Mobile_App_Title_Details_Page_Tab_Details_Section = {
  __typename?: 'mobile_app_title_details_page_tab_details_section';
  texts: Array<Mobile_App_Title_Details_Page_Tab_Details_Text>;
  title: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Tab_Details_Text = {
  __typename?: 'mobile_app_title_details_page_tab_details_text';
  leading_image_url?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Mobile_App_Title_Details_Page_Tab_Episodes = {
  __typename?: 'mobile_app_title_details_page_tab_episodes';
  items?: Maybe<Array<Mobile_App_Thumb_Episode_Landscape>>;
  modules?: Maybe<Array<Mobile_App_Title_Details_Page_Module>>;
  name: Scalars['String']['output'];
  selected_module_index?: Maybe<Scalars['Int']['output']>;
};

export type Mobile_App_Title_Details_Page_Tab_Extras = {
  __typename?: 'mobile_app_title_details_page_tab_extras';
  carousels?: Maybe<Array<Mobile_App_Carousel>>;
  materials?: Maybe<Mobile_App_Title_Details_Page_Materials_Section>;
  name: Scalars['String']['output'];
};

export type Mobile_App_Trending_Item = {
  __typename?: 'mobile_app_trending_item';
  action: Mobile_App_Action;
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lock_icon: Scalars['Boolean']['output'];
  share_data: Mobile_App_Share_Data;
  subtitle: Scalars['String']['output'];
  thumbnail?: Maybe<Mobile_App_Thumbnail>;
  title: Scalars['String']['output'];
};

export type Mobile_App_Trending_Page = {
  __typename?: 'mobile_app_trending_page';
  items: Array<Mobile_App_Trending_Item>;
  title: Scalars['String']['output'];
};

/** A module */
export type Module = {
  __typename?: 'module';
  allowed: Scalars['Boolean']['output'];
  /** An audio for an entire module, with all classes together. Blame it on the production folks */
  audio?: Maybe<Audio>;
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  materials?: Maybe<Array<Material>>;
  medias: Array<Media>;
  name: Scalars['String']['output'];
  playlist: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** A release date for upcoming content */
  release_date?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Image>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type My_Bp = {
  __typename?: 'my_bp';
  medias: Array<Media>;
  titles: Array<Playlist>;
};

export type My_Bp_Update_Media_Input = {
  added: Scalars['Boolean']['input'];
  media_id: Scalars['String']['input'];
};

export type My_Bp_Update_Media_Response = Error | My_Bp_Update_Media_Success;

export type My_Bp_Update_Media_Success = {
  __typename?: 'my_bp_update_media_success';
  added: Scalars['Boolean']['output'];
  media_id: Scalars['String']['output'];
};

export type My_Bp_Update_Title_Input = {
  added: Scalars['Boolean']['input'];
  title_id: Scalars['String']['input'];
};

export type My_Bp_Update_Title_Response = Error | My_Bp_Update_Title_Success;

export type My_Bp_Update_Title_Success = {
  __typename?: 'my_bp_update_title_success';
  added: Scalars['Boolean']['output'];
  title_id: Scalars['String']['output'];
};

export type Next_Allowed_Operation = {
  __typename?: 'next_allowed_operation';
  execute_after?: Maybe<Scalars['Int']['output']>;
  freezing_deadline?: Maybe<Scalars['Int']['output']>;
  operation_name: Scalars['String']['output'];
  prohibited_reason?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Nupay = {
  __typename?: 'nupay';
  tid: Scalars['String']['output'];
};

export type Oauth_Client = {
  __typename?: 'oauth_client';
  client_id: Scalars['String']['output'];
  client_name: Scalars['String']['output'];
};

export type Oauth_Client_Response = Error | Oauth_Client;

export type Offer = {
  __typename?: 'offer';
  active?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  broker_name?: Maybe<Scalars['String']['output']>;
  broker_offer_id: Scalars['String']['output'];
  broker_product_id: Scalars['String']['output'];
  cents_amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Discount>;
  granted_scholarships?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  max_cycles?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product: Subscription_Plan;
};

export type Operation_Executed = {
  __typename?: 'operation_executed';
  message: Scalars['String']['output'];
  operation_info?: Maybe<Operation_Info>;
};

export type Operation_Info = {
  __typename?: 'operation_info';
  operation: Scalars['String']['output'];
  support_automatic_refund?: Maybe<Scalars['Boolean']['output']>;
};

export type Page = {
  __typename?: 'page';
  banner?: Maybe<Banner>;
  categories: Array<Category>;
  most_recent_course: Playlist;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
  v: Scalars['Int']['output'];
};

export type Parent = {
  __typename?: 'parent';
  id: Scalars['String']['output'];
};

export type Payment_Methods = {
  __typename?: 'payment_methods';
  payment_methods: Array<Scalars['String']['output']>;
};

export type Payment_Methods_Either = Error | Payment_Methods;

export type Payment_Operation = {
  __typename?: 'payment_operation';
  last_operation: Last_Operation;
  next_allowed_operations: Array<Next_Allowed_Operation>;
};

export type Payment_Operation_Response = Error | Operation_Executed;

export type Payment_Settings = {
  __typename?: 'payment_settings';
  credit_card?: Maybe<Credit_Card>;
  installments?: Maybe<Scalars['Int']['output']>;
  payment_method: Scalars['String']['output'];
};

export type Pix = {
  __typename?: 'pix';
  expiration_date: Scalars['String']['output'];
  qrcode: Qrcode;
};

export type Platform_Data = {
  __typename?: 'platform_data';
  instagram?: Maybe<Instagram_Data>;
};

export type Player_Language_Button = {
  __typename?: 'player_language_button';
  label: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  settings: Button_Language_Settings;
};

export type Player_Language_Settings = {
  __typename?: 'player_language_settings';
  buttons: Array<Player_Language_Button>;
  save_user_preferences: Scalars['Boolean']['output'];
};

export type Playlist = {
  __typename?: 'playlist';
  airplay_enabled?: Maybe<Scalars['Boolean']['output']>;
  allowed: Scalars['Boolean']['output'];
  bff_metadata?: Maybe<Scalars['String']['output']>;
  bibliography?: Maybe<Scalars['String']['output']>;
  cast?: Maybe<Array<Scalars['String']['output']>>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  completed_count: Scalars['Int']['output'];
  content_review?: Maybe<Scalars['String']['output']>;
  cover: Image;
  created_at: Scalars['String']['output'];
  current_media: Media;
  current_module_thumbnail?: Maybe<Image>;
  description?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<Scalars['String']['output']>>;
  dvd?: Maybe<Image>;
  episodes_count: Scalars['Int']['output'];
  freemium_banner_img?: Maybe<Image>;
  has_allowed_resources: Scalars['Boolean']['output'];
  hero?: Maybe<Image>;
  hero_web?: Maybe<Image>;
  id: Scalars['String']['output'];
  interviews: Array<Playlist>;
  last_viewed_media_id: Scalars['String']['output'];
  launch_date: Scalars['String']['output'];
  level?: Maybe<Level>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_obj?: Maybe<Image>;
  media_count: Scalars['Int']['output'];
  medias?: Maybe<Array<Media>>;
  modules: Array<Module>;
  my_bp_added: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  next_media?: Maybe<Media>;
  parent_playlist_slug?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Raw_Source>;
  rating?: Maybe<Rating>;
  release_date: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  selected_thumbnail?: Maybe<Selected_Thumbnail>;
  shareable_info: Shareable_Info;
  slug: Scalars['String']['output'];
  teacher?: Maybe<Teacher>;
  thumbnail: Image;
  thumbnails?: Maybe<Thumbnails>;
  type: Playlist_Type;
  type_str: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  v: Scalars['Int']['output'];
};

export type Playlist_Type = {
  __typename?: 'playlist_type';
  name: Scalars['String']['output'];
};

export type Product = {
  __typename?: 'product';
  cancel_at_cycle_end?: Maybe<Scalars['Boolean']['output']>;
  cycle_started_at: Scalars['String']['output'];
  gateway_code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_payment_operation: Payment_Operation;
  last_transaction: Transaction;
  next_cycle_at: Scalars['String']['output'];
  recurrency_period: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscription_plan: Subscription_Plan;
  type: Scalars['String']['output'];
};

export type Product_Card = {
  __typename?: 'product_card';
  allowed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  playlist_id: Scalars['String']['output'];
  playlist_slug: Scalars['String']['output'];
  progress: Product_Progress;
  thumbnail: App_Image;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Product_Change_Info = Error | Simulated_Product_Change_Info;

export type Product_Change_Info_Input = {
  gateway_code: Scalars['String']['input'];
  offer_id: Scalars['String']['input'];
};

export type Product_Page = {
  __typename?: 'product_page';
  certification_info?: Maybe<Certification_Info>;
  classes_cards?: Maybe<Array<Catalog_Card>>;
  collapse_sections?: Maybe<Array<Collapse_Section>>;
  header: Product_Page_Header;
};

export type Product_Page_Header = {
  __typename?: 'product_page_header';
  background_image?: Maybe<App_Image>;
  description: Scalars['String']['output'];
  logo_image?: Maybe<App_Image>;
  mobile_background_image?: Maybe<App_Image>;
  progress?: Maybe<Product_Progress>;
  rating?: Maybe<Rating>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Product_Progress = {
  __typename?: 'product_progress';
  completed?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  status_id: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type Product_Subscriptions = {
  __typename?: 'product_subscriptions';
  access_since: Scalars['String']['output'];
  access_type: Scalars['String']['output'];
  access_until: Scalars['String']['output'];
  id: Scalars['String']['output'];
  payment_error: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  subscriptions: Array<Deprecated_Subscription>;
  warning: Scalars['Boolean']['output'];
};

export type Products_Page = {
  __typename?: 'products_page';
  components: Array<Product_Card>;
};

export type Purchases = {
  __typename?: 'purchases';
  current_subscription?: Maybe<Subscription>;
  products?: Maybe<Array<Product>>;
  subscriptions?: Maybe<Array<Subscription>>;
};

export type Purgatorium_Maybe_Token = {
  __typename?: 'purgatorium_maybe_token';
  refresh?: Maybe<Scalars['String']['output']>;
  session_valid: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type Purgatorium_Session = {
  __typename?: 'purgatorium_session';
  code: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type Purgatorium_Token_Input = {
  code: Scalars['String']['input'];
  invitation?: InputMaybe<Scalars['String']['input']>;
  refresh?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type Qrcode = {
  __typename?: 'qrcode';
  signature: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Rating = {
  __typename?: 'rating';
  advisory: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Raw_Source = {
  __typename?: 'raw_source';
  height: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type Reactivate_Subscription_Input = {
  gateway_code: Scalars['String']['input'];
};

export type Refresh_Token_Input = {
  refresh_token: Scalars['String']['input'];
};

export type Related_Content = {
  __typename?: 'related_content';
  aspect_ratio: Aspect_Ratio;
  items: Array<Related_Content_Card>;
};

export type Related_Content_Card = {
  __typename?: 'related_content_card';
  allowed: Scalars['Boolean']['output'];
  card_subtitle?: Maybe<Scalars['String']['output']>;
  card_title?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  metadata: Related_Content_Card_Metadata;
  thumbnail: Image;
};

export type Related_Content_Card_Metadata = {
  __typename?: 'related_content_card_metadata';
  content_id: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
};

export type Remove_Current_Download = Error | Removed_Download;

export type Remove_Current_Download_Input = {
  device_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
};

export type Removed_Download = {
  __typename?: 'removed_download';
  remove: Scalars['String']['output'];
};

export type Reset_Password_Input = {
  password: Scalars['String']['input'];
  reset_token: Scalars['String']['input'];
};

export type Revert_Change_Product_Input = {
  gateway_code: Scalars['String']['input'];
};

export type Ribbon = {
  __typename?: 'ribbon';
  colors: Component_Colors;
  countdown: Scalars['Boolean']['output'];
  cta?: Maybe<Button>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'role';
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type Schedule = {
  __typename?: 'schedule';
  description?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Screen_Requested_Input = {
  item_id?: InputMaybe<Scalars['String']['input']>;
  live_id?: InputMaybe<Scalars['String']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  playlist_id?: InputMaybe<Scalars['String']['input']>;
  view: Scalars['String']['input'];
};

export type Screen_Sessions = {
  __typename?: 'screen_sessions';
  allow_reproduction: Scalars['Boolean']['output'];
  plan_max_screens: Scalars['Int']['output'];
  skip_tv_check?: Maybe<Scalars['Boolean']['output']>;
};

export type Search_Result = {
  __typename?: 'search_result';
  interviews: Array<Playlist>;
  medias: Array<Media>;
  titles: Array<Playlist>;
};

export type Selected_Thumbnail = {
  __typename?: 'selected_thumbnail';
  aspect_ratio: Aspect_Ratio;
  image: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type Send_Privacy_Form_Input = {
  cpf: Scalars['String']['input'];
  details: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Share_Campaign = {
  __typename?: 'share_campaign';
  counter: Share_Campaign_Counter;
  description?: Maybe<Scalars['String']['output']>;
  goal: Share_Campaign_Goal;
};

export type Share_Campaign_Counter = {
  __typename?: 'share_campaign_counter';
  description: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type Share_Campaign_Either = Error | Share_Campaign;

export type Share_Campaign_Goal = {
  __typename?: 'share_campaign_goal';
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shareable_Info = {
  __typename?: 'shareable_info';
  content_id: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  direct_message_text: Scalars['String']['output'];
  hashtags: Array<Scalars['String']['output']>;
  media_name?: Maybe<Scalars['String']['output']>;
  platform_data?: Maybe<Platform_Data>;
  playlist_name: Scalars['String']['output'];
  playlist_slug: Scalars['String']['output'];
  public_text: Scalars['String']['output'];
  sharing_enabled: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type Simulated_Product_Change_Info = {
  __typename?: 'simulated_product_change_info';
  charge_date?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  gateway_code?: Maybe<Scalars['String']['output']>;
  installments?: Maybe<Scalars['Int']['output']>;
  offer: Offer;
  operation: Scalars['String']['output'];
  payment_method?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type Source = {
  __typename?: 'source';
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'subscription';
  cancel_at_cycle_end?: Maybe<Scalars['Boolean']['output']>;
  cycle_started_at: Scalars['String']['output'];
  expires_in: Scalars['String']['output'];
  gateway_code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_payment_operation: Payment_Operation;
  last_transaction: Transaction;
  next_cycle_at: Scalars['String']['output'];
  next_cycle_cents_amount?: Maybe<Scalars['Int']['output']>;
  offer?: Maybe<Offer>;
  payment_settings?: Maybe<Payment_Settings>;
  recurrence_type?: Maybe<Scalars['String']['output']>;
  recurrency: Scalars['Int']['output'];
  recurrency_period: Scalars['Int']['output'];
  renewal_offer?: Maybe<Offer>;
  status: Scalars['String']['output'];
  subscription_plan: Subscription_Plan;
  type: Scalars['String']['output'];
};

export type Subscription_Plan = {
  __typename?: 'subscription_plan';
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  role: Scalars['String']['output'];
};

export type Successfully_Synced = {
  __typename?: 'successfully_synced';
  payment_settings: Payment_Settings;
};

export type Sync_Media_Status = {
  __typename?: 'sync_media_status';
  key: Scalars['String']['output'];
};

export type Sync_Payment_Settings_Input = {
  gateway_code: Scalars['String']['input'];
};

export type Sync_Payment_Settings_Response = Error | Successfully_Synced;

export type Sync_Success = {
  __typename?: 'sync_success';
  not_valid: Array<Sync_Media_Status>;
  valid: Array<Sync_Media_Status>;
};

export type Sync_With_Client_Input = {
  device_id: Scalars['String']['input'];
  downloads: Array<Scalars['String']['input']>;
};

export type Sync_With_Client_Status = Error | Sync_Success;

export type Teacher = {
  __typename?: 'teacher';
  avatar?: Maybe<Image>;
  biography?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Thumb = {
  __typename?: 'thumb';
  cloudinary_path: Scalars['String']['output'];
};

export type Thumbnails = {
  __typename?: 'thumbnails';
  dvd?: Maybe<Image>;
  fifty_one_sixty?: Maybe<Image>;
  sixteen_nine?: Maybe<Image>;
};

export type Transaction = {
  __typename?: 'transaction';
  amount: Scalars['Int']['output'];
  billet?: Maybe<Billet>;
  broker_id: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  credit_card?: Maybe<Credit_Card>;
  gateway_code: Scalars['String']['output'];
  installments?: Maybe<Installments>;
  nupay?: Maybe<Nupay>;
  pix?: Maybe<Pix>;
  status: Scalars['String']['output'];
};

export type Tv_App_Banner = {
  __typename?: 'tv_app_banner';
  background_image: Scalars['String']['output'];
  cast?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  directors?: Maybe<Array<Scalars['String']['output']>>;
  duration?: Maybe<Scalars['String']['output']>;
  extra_info?: Maybe<Array<Scalars['String']['output']>>;
  keep_watching_info?: Maybe<Tv_App_Progress_Bar>;
  logo?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Tv_App_Rating>;
  release_year?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  teachers?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Button = {
  __typename?: 'tv_app_button';
  event: Tv_App_Event;
  icon: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Tv_App_Card = {
  __typename?: 'tv_app_card';
  banner: Tv_App_Banner;
  bottom_subtitle?: Maybe<Scalars['String']['output']>;
  event: Tv_App_Event;
  human_duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lock_icon?: Maybe<Scalars['Boolean']['output']>;
  original_icon?: Maybe<Scalars['Boolean']['output']>;
  play_icon?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Tv_App_Progress_Bar>;
  status?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail: Tv_App_Thumbnail;
  time_label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Carousel = {
  __typename?: 'tv_app_carousel';
  id: Scalars['String']['output'];
  items: Array<Tv_App_Card>;
  nav_hash: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Component = Tv_App_Carousel | Tv_App_Grid | Tv_App_Highlights | Tv_App_Keep_Watching | Tv_App_Lives_Carousel | Tv_App_Tab_Set;

export type Tv_App_Error_Page = {
  __typename?: 'tv_app_error_page';
  error_type: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Tv_App_Event = Tv_App_Go_To_List_Page | Tv_App_Go_To_Live_Player | Tv_App_Go_To_Paywall_Page | Tv_App_Go_To_Player | Tv_App_Go_To_Playlist_Detail | Tv_App_Update_Title_My_Bp;

export type Tv_App_Go_To_List_Page = {
  __typename?: 'tv_app_go_to_list_page';
  slug: Scalars['String']['output'];
};

export type Tv_App_Go_To_Live_Player = {
  __typename?: 'tv_app_go_to_live_player';
  live_sse_url: Scalars['String']['output'];
  playback_url?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Go_To_Paywall_Page = {
  __typename?: 'tv_app_go_to_paywall_page';
  background_image: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qr_code_url: Scalars['String']['output'];
};

export type Tv_App_Go_To_Player = {
  __typename?: 'tv_app_go_to_player';
  media_id: Scalars['String']['output'];
  playlist_slug: Scalars['String']['output'];
};

export type Tv_App_Go_To_Playlist_Detail = {
  __typename?: 'tv_app_go_to_playlist_detail';
  slug: Scalars['String']['output'];
};

export type Tv_App_Grid = {
  __typename?: 'tv_app_grid';
  columns: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  items: Array<Tv_App_Card>;
  nav_hash: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Highlights = {
  __typename?: 'tv_app_highlights';
  items: Array<Tv_App_Card>;
  nav_hash: Scalars['String']['output'];
};

export type Tv_App_Icon = Tv_App_Icon_Svg | Tv_App_Icon_Url;

export type Tv_App_Icon_Svg = {
  __typename?: 'tv_app_icon_svg';
  svg_id: Scalars['String']['output'];
};

export type Tv_App_Icon_Url = {
  __typename?: 'tv_app_icon_url';
  url: Scalars['String']['output'];
};

export type Tv_App_Keep_Watching = {
  __typename?: 'tv_app_keep_watching';
  id: Scalars['String']['output'];
  items: Array<Tv_App_Keep_Watching_Item>;
  nav_hash: Scalars['String']['output'];
};

export type Tv_App_Keep_Watching_Item = {
  __typename?: 'tv_app_keep_watching_item';
  banner: Tv_App_Banner;
  duration_seconds: Scalars['Int']['output'];
  event: Tv_App_Event;
  human_duration: Scalars['String']['output'];
  id: Scalars['String']['output'];
  progress: Tv_App_Progress_Bar;
  subtitle: Scalars['String']['output'];
  thumbnail: Tv_App_Thumbnail;
  title: Scalars['String']['output'];
};

export type Tv_App_List_Page = {
  __typename?: 'tv_app_list_page';
  components: Array<Tv_App_Component>;
  /**
   * Position index of keep-watching carousel.
   *             Since it is loaded by a separate query.
   */
  keep_watching_position: Scalars['Int']['output'];
};

export type Tv_App_Live_Banner = {
  __typename?: 'tv_app_live_banner';
  background_image: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  time_label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Tv_App_Live_Card = {
  __typename?: 'tv_app_live_card';
  banner: Tv_App_Live_Banner;
  event: Tv_App_Go_To_Live_Player;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  thumbnail: Tv_App_Thumbnail;
  time_label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Tv_App_Lives_Carousel = {
  __typename?: 'tv_app_lives_carousel';
  id: Scalars['String']['output'];
  items: Array<Tv_App_Live_Card>;
  nav_hash: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Menu = {
  __typename?: 'tv_app_menu';
  items: Array<Tv_App_Menu_Item>;
};

export type Tv_App_Menu_Item = {
  __typename?: 'tv_app_menu_item';
  icon: Tv_App_Icon;
  index: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  page_id: Scalars['String']['output'];
};

export type Tv_App_My_Bp_Button = {
  __typename?: 'tv_app_my_bp_button';
  added: Scalars['Boolean']['output'];
  event: Tv_App_Event;
  title: Scalars['String']['output'];
};

export type Tv_App_Paywall = {
  __typename?: 'tv_app_paywall';
  background_image: Scalars['String']['output'];
  message: Scalars['String']['output'];
  qr_code_url: Scalars['String']['output'];
};

export type Tv_App_Progress_Bar = {
  __typename?: 'tv_app_progress_bar';
  completion_percentage?: Maybe<Scalars['Int']['output']>;
  current_media_description?: Maybe<Scalars['String']['output']>;
  remaining_description?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Rating = {
  __typename?: 'tv_app_rating';
  advisory?: Maybe<Array<Scalars['String']['output']>>;
  url: Scalars['String']['output'];
};

export type Tv_App_Review_Button = {
  __typename?: 'tv_app_review_button';
  event: Tv_App_Update_Title_Review;
  review?: Maybe<Scalars['String']['output']>;
};

export type Tv_App_Search = {
  __typename?: 'tv_app_search';
  components: Array<Tv_App_Component>;
};

export type Tv_App_Tab_Empty_Fallback = {
  __typename?: 'tv_app_tab_empty_fallback';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Tv_App_Tab_Item = {
  __typename?: 'tv_app_tab_item';
  components: Array<Tv_App_Component>;
  empty_fallback?: Maybe<Tv_App_Tab_Empty_Fallback>;
  label: Scalars['String']['output'];
};

export type Tv_App_Tab_Set = {
  __typename?: 'tv_app_tab_set';
  active_card_index?: Maybe<Scalars['Int']['output']>;
  active_tab_index?: Maybe<Scalars['Int']['output']>;
  nav_hash: Scalars['String']['output'];
  tabs: Array<Tv_App_Tab_Item>;
};

export type Tv_App_Thumbnail = {
  __typename?: 'tv_app_thumbnail';
  aspect_ratio: Scalars['String']['output'];
  image: Scalars['String']['output'];
};

export type Tv_App_Title_Detail_Banner = {
  __typename?: 'tv_app_title_detail_banner';
  general_info: Tv_App_Banner;
  main_button: Tv_App_Button;
  my_bp_button?: Maybe<Tv_App_My_Bp_Button>;
  review_button?: Maybe<Tv_App_Review_Button>;
};

export type Tv_App_Title_Detail_Page = Tv_App_Error_Page | Tv_App_Paywall | Tv_App_Title_Detail_Page_Content;

export type Tv_App_Title_Detail_Page_Content = {
  __typename?: 'tv_app_title_detail_page_content';
  banner: Tv_App_Title_Detail_Banner;
  certification_info?: Maybe<Certification_Info>;
  components: Array<Tv_App_Component>;
  type: Scalars['String']['output'];
};

export type Tv_App_Update_Title_My_Bp = {
  __typename?: 'tv_app_update_title_my_bp';
  title_id: Scalars['String']['output'];
};

export type Tv_App_Update_Title_Review = {
  __typename?: 'tv_app_update_title_review';
  title_id: Scalars['String']['output'];
};

export type Update_Avatar_Input = {
  avatar: Scalars['String']['input'];
  image_ext: Scalars['String']['input'];
};

export type Update_Checkpoint_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  checkpoint: Scalars['Float']['input'];
  client_generated_at?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  media: Scalars['String']['input'];
  os_version?: InputMaybe<Scalars['String']['input']>;
  playlist: Scalars['String']['input'];
  stream_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Ended_Input = {
  media: Scalars['String']['input'];
  playlist: Scalars['String']['input'];
};

export type Update_Media_Completed_Input = {
  completed: Scalars['Boolean']['input'];
  media: Scalars['String']['input'];
  playlist: Scalars['String']['input'];
};

export type Update_Profile_Input = {
  address: Address_Input;
  birthday: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parental_rating?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phone_local_code?: InputMaybe<Scalars['String']['input']>;
  profession: Scalars['String']['input'];
};

export type User = {
  __typename?: 'user';
  address: Address;
  ads: Scalars['Boolean']['output'];
  avatar: Image;
  /** Badge text can be different from the plan.For example, when a user has a premium plan and he is 'fundador', his badge is 'fundador'. */
  badge: Scalars['String']['output'];
  badges?: Maybe<Array<Badges>>;
  birthday: Scalars['String']['output'];
  can_access_certifications: Scalars['Boolean']['output'];
  cookies: Cookies;
  created_at: Scalars['String']['output'];
  email: Scalars['String']['output'];
  free_content_watched?: Maybe<Array<Content>>;
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Informations that can be used to identify the user in external systems. */
  interactions_info?: Maybe<Interactions_Info>;
  last_agent: Version;
  name: Scalars['String']['output'];
  parental_rating?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phone_local_code: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  products?: Maybe<Array<Scalars['String']['output']>>;
  profession: Scalars['String']['output'];
  roles: Array<Role>;
  settings: User_Settings;
  show_comments_disclaimer?: Maybe<Scalars['Boolean']['output']>;
  subscription_plan_display_name: Scalars['String']['output'];
  upsell: Scalars['String']['output'];
};

export type User_Comments_Disclaimer = {
  __typename?: 'user_comments_disclaimer';
  show_comments_disclaimer: Scalars['Boolean']['output'];
};

export type User_Comments_Disclaimer_Either = Error | User_Comments_Disclaimer;

export type User_Device = {
  __typename?: 'user_device';
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type User_Device_Either = Error | User_Device;

export type User_Gifts = {
  __typename?: 'user_gifts';
  gift_cards: Array<Gift_Card>;
};

export type User_Profile = {
  __typename?: 'user_profile';
  address: Address;
  avatar: Image;
  birthday: Scalars['String']['output'];
  email: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parental_rating?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phone_local_code?: Maybe<Scalars['String']['output']>;
  plan: Scalars['String']['output'];
  profession: Scalars['String']['output'];
};

export type User_Profile_Either = Error | User_Profile;

export type User_Settings = {
  __typename?: 'user_settings';
  bp_kids: User_Settings_Bp_Kids;
  player: User_Settings_Player;
};

export type User_Settings_Bp_Kids = {
  __typename?: 'user_settings_bp_kids';
  required_pin: Scalars['Boolean']['output'];
};

export type User_Settings_Bp_Kids_Input = {
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type User_Settings_Either = Error | User_Settings;

export type User_Settings_Input = {
  bp_kids?: InputMaybe<User_Settings_Bp_Kids_Input>;
  player?: InputMaybe<User_Settings_Player_Input>;
};

export type User_Settings_Language = {
  __typename?: 'user_settings_language';
  audio: Scalars['String']['output'];
  subtitles: Scalars['String']['output'];
};

export type User_Settings_Language_Input = {
  audio: Scalars['String']['input'];
  subtitles: Scalars['String']['input'];
};

export type User_Settings_Player = {
  __typename?: 'user_settings_player';
  language: User_Settings_Language;
};

export type User_Settings_Player_Input = {
  language: User_Settings_Language_Input;
};

export type Version = {
  __typename?: 'version';
  device?: Maybe<Version>;
  family: Scalars['String']['output'];
  major: Scalars['String']['output'];
  minor: Scalars['String']['output'];
  os?: Maybe<Version>;
  patch: Scalars['String']['output'];
};

export type RefreshTokenMutationVariables = Exact<{
  input: Refresh_Token_Input;
}>;


export type RefreshTokenMutation = { __typename?: 'MutationRoot', refresh_token: { __typename: 'auth', token: string, refresh: string } | { __typename: 'error', message: string } };

export type GetCastStandbyPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCastStandbyPageQuery = { __typename?: 'QueryRoot', mobile_app_cast_standby_page: { __typename?: 'mobile_app_cast_standby_page', items: Array<{ __typename?: 'mobile_app_cast_standby_item', background_image: string, description: string, details: string, directors: Array<string>, logo: string, rating_image: string }> } | { __typename?: 'mobile_app_error', error_type: string, message: string } };

export type GetDrmLicenseV2QueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
  drmType: Scalars['String']['input'];
  licenseChallenge: Scalars['String']['input'];
}>;


export type GetDrmLicenseV2Query = { __typename?: 'QueryRoot', drm_license_v_2: { __typename?: 'error', message: string } | { __typename?: 'license', license: string } };

export type GetLiveQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLiveQuery = { __typename?: 'QueryRoot', live: { __typename?: 'live', id: string, name: string, description: string, time_label: string, status: string, mux_playback_url?: string | null, thumb: { __typename?: 'thumb', cloudinary_path: string } } };

export type GetMediaQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
  playlistId: Scalars['String']['input'];
}>;


export type GetMediaQuery = { __typename?: 'QueryRoot', media: { __typename?: 'media', name: string, checkpoint: number, duration: number, manifest: { __typename?: 'manifest', url: string }, thumbnail?: { __typename?: 'image', image: string } | null, playlist: { __typename?: 'playlist', name: string, type_str: string, thumbnails?: { __typename?: 'thumbnails', dvd?: { __typename?: 'image', image: string } | null } | null } } };

export type GetMediaBySlugQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
  playlistSlug: Scalars['String']['input'];
}>;


export type GetMediaBySlugQuery = { __typename?: 'QueryRoot', media: { __typename?: 'media', name: string, checkpoint: number, duration: number, manifest: { __typename?: 'manifest', url: string }, thumbnail?: { __typename?: 'image', image: string } | null, playlist: { __typename?: 'playlist', id: string, name: string, slug: string, type_str: string, thumbnails?: { __typename?: 'thumbnails', dvd?: { __typename?: 'image', image: string } | null } | null } } };

export type GetNextMediaQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
  playlistId: Scalars['String']['input'];
}>;


export type GetNextMediaQuery = { __typename?: 'QueryRoot', media: { __typename?: 'media', next_media_object?: { __typename?: 'media', id: string, name: string, checkpoint: number, duration: number, manifest: { __typename?: 'manifest', url: string } } | null, playlist: { __typename?: 'playlist', id: string, name: string, slug: string, type_str: string, thumbnails?: { __typename?: 'thumbnails', dvd?: { __typename?: 'image', image: string } | null } | null } } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'QueryRoot', user: { __typename?: 'user', id: string, name: string, avatar: { __typename?: 'image', image: string } } };

export type GetUserLanguageSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLanguageSettingsQuery = { __typename?: 'QueryRoot', user: { __typename?: 'user', settings: { __typename?: 'user_settings', player: { __typename?: 'user_settings_player', language: { __typename?: 'user_settings_language', audio: string, subtitles: string } } } } };

export type UpdateCheckpointMutationVariables = Exact<{
  input: Update_Checkpoint_Input;
}>;


export type UpdateCheckpointMutation = { __typename?: 'MutationRoot', update_checkpoint: string };

export type UpdateEndedMutationVariables = Exact<{
  input: Update_Ended_Input;
}>;


export type UpdateEndedMutation = { __typename?: 'MutationRoot', update_ended: string };

export type UpdateUserLanguageSettingsMutationVariables = Exact<{
  input: User_Settings_Input;
}>;


export type UpdateUserLanguageSettingsMutation = { __typename?: 'MutationRoot', update_user_settings: { __typename: 'error', message: string } | { __typename: 'user_settings', player: { __typename?: 'user_settings_player', language: { __typename?: 'user_settings_language', audio: string, subtitles: string } } } };


export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: refresh_token_input!) {
  refresh_token(input: $input) {
    __typename
    ... on auth {
      token
      refresh
    }
    ... on error {
      message
    }
  }
}
    `;
export const GetCastStandbyPageDocument = gql`
    query GetCastStandbyPage {
  mobile_app_cast_standby_page {
    ... on mobile_app_cast_standby_page {
      items {
        background_image
        description
        details
        directors
        logo
        rating_image
      }
    }
    ... on mobile_app_error {
      error_type
      message
    }
  }
}
    `;
export const GetDrmLicenseV2Document = gql`
    query GetDRMLicenseV2($mediaId: String!, $drmType: String!, $licenseChallenge: String!) {
  drm_license_v_2(
    media_id: $mediaId
    drm_type: $drmType
    license_challenge: $licenseChallenge
  ) {
    ... on license {
      license
    }
    ... on error {
      message
    }
  }
}
    `;
export const GetLiveDocument = gql`
    query GetLive($id: String!) {
  live(id: $id) {
    id
    name
    description
    time_label
    status
    mux_playback_url
    thumb {
      cloudinary_path
    }
  }
}
    `;
export const GetMediaDocument = gql`
    query GetMedia($mediaId: String!, $playlistId: String!) {
  media(media_id: $mediaId, playlistid: $playlistId) {
    name
    checkpoint
    duration
    manifest(type: "mpd") {
      url
    }
    thumbnail {
      image
    }
    playlist {
      name
      type_str
      thumbnails {
        dvd {
          image
        }
      }
    }
  }
}
    `;
export const GetMediaBySlugDocument = gql`
    query GetMediaBySlug($mediaId: String!, $playlistSlug: String!) {
  media(media_id: $mediaId, playlistslug: $playlistSlug) {
    name
    checkpoint
    duration
    manifest(type: "mpd") {
      url
    }
    thumbnail {
      image
    }
    playlist {
      id
      name
      slug
      type_str
      thumbnails {
        dvd {
          image
        }
      }
    }
  }
}
    `;
export const GetNextMediaDocument = gql`
    query GetNextMedia($mediaId: String!, $playlistId: String!) {
  media(media_id: $mediaId, playlistid: $playlistId) {
    next_media_object {
      id
      name
      checkpoint
      duration
      manifest(type: "mpd") {
        url
      }
    }
    playlist {
      id
      name
      slug
      type_str
      thumbnails {
        dvd {
          image
        }
      }
    }
  }
}
    `;
export const GetUserDocument = gql`
    query GetUser {
  user {
    id
    name
    avatar {
      image
    }
  }
}
    `;
export const GetUserLanguageSettingsDocument = gql`
    query GetUserLanguageSettings {
  user {
    settings {
      player {
        language {
          audio
          subtitles
        }
      }
    }
  }
}
    `;
export const UpdateCheckpointDocument = gql`
    mutation UpdateCheckpoint($input: update_checkpoint_input!) {
  update_checkpoint(input: $input)
}
    `;
export const UpdateEndedDocument = gql`
    mutation UpdateEnded($input: update_ended_input!) {
  update_ended(input: $input)
}
    `;
export const UpdateUserLanguageSettingsDocument = gql`
    mutation UpdateUserLanguageSettings($input: user_settings_input!) {
  update_user_settings(input: $input) {
    __typename
    ... on user_settings {
      player {
        language {
          audio
          subtitles
        }
      }
    }
    ... on error {
      message
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    RefreshToken(variables: RefreshTokenMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RefreshTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshTokenMutation>(RefreshTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RefreshToken', 'mutation');
    },
    GetCastStandbyPage(variables?: GetCastStandbyPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCastStandbyPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCastStandbyPageQuery>(GetCastStandbyPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCastStandbyPage', 'query');
    },
    GetDRMLicenseV2(variables: GetDrmLicenseV2QueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDrmLicenseV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDrmLicenseV2Query>(GetDrmLicenseV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDRMLicenseV2', 'query');
    },
    GetLive(variables: GetLiveQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLiveQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLiveQuery>(GetLiveDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLive', 'query');
    },
    GetMedia(variables: GetMediaQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMediaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMediaQuery>(GetMediaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMedia', 'query');
    },
    GetMediaBySlug(variables: GetMediaBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMediaBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMediaBySlugQuery>(GetMediaBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMediaBySlug', 'query');
    },
    GetNextMedia(variables: GetNextMediaQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetNextMediaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNextMediaQuery>(GetNextMediaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetNextMedia', 'query');
    },
    GetUser(variables?: GetUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUser', 'query');
    },
    GetUserLanguageSettings(variables?: GetUserLanguageSettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserLanguageSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserLanguageSettingsQuery>(GetUserLanguageSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserLanguageSettings', 'query');
    },
    UpdateCheckpoint(variables: UpdateCheckpointMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCheckpointMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCheckpointMutation>(UpdateCheckpointDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCheckpoint', 'mutation');
    },
    UpdateEnded(variables: UpdateEndedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateEndedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEndedMutation>(UpdateEndedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEnded', 'mutation');
    },
    UpdateUserLanguageSettings(variables: UpdateUserLanguageSettingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserLanguageSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserLanguageSettingsMutation>(UpdateUserLanguageSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserLanguageSettings', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;